import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/sku-variants";

// List variants for the logged-in account (account derived from token server-side).
export const fetchSkuVariants = createAsyncThunk(
  "skuVariant/fetchSkuVariants",
  async (params?: string): Promise<any> => {
    const query = params ? `?${params}` : "";
    const response = await axios.get(`${BASE}${query}`);
    return response.data; // array of variants
  }
);

export const addSkuVariant = createAsyncThunk(
  "skuVariant/addSkuVariant",
  async (payload: any): Promise<any> => {
    const response = await axios.post(BASE, payload);
    return response.data;
  }
);

export const updateSkuVariant = createAsyncThunk(
  "skuVariant/updateSkuVariant",
  async ({ id, payload }: { id: string; payload: any }): Promise<any> => {
    const response = await axios.put(`${BASE}/${id}`, payload);
    return response.data;
  }
);

export const deleteSkuVariant = createAsyncThunk(
  "skuVariant/deleteSkuVariant",
  async (id: string): Promise<any> => {
    const response = await axios.delete(`${BASE}/${id}`);
    return response.data;
  }
);
